
export type GetCourseDraftsFilter = typeof GetCourseDraftsFilter[keyof typeof GetCourseDraftsFilter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourseDraftsFilter = {
  my_drafts: 'my_drafts',
} as const;
